import React from "react";
import { Button, Card, Divider, Stack, TextField, Typography } from "@mui/material";

interface ProjectCompletionNoteCardProps {
  note: string;
  onChange: (note: string) => void;
  onSave?: () => void | Promise<void>;
  minLength: number;
  editable: boolean;
  saveDisabled?: boolean;
  saveLoading?: boolean;
  sx?: object;
}

const ProjectCompletionNoteCard = ({
  note,
  onChange,
  onSave,
  minLength,
  editable,
  saveDisabled = false,
  saveLoading = false,
  sx,
}: ProjectCompletionNoteCardProps) => {
  const trimmedLength = note.trim().length;

  return (
    <Card sx={{ mt: 4, paddingX: 4, paddingY: 2, ...sx }}>
      <Typography variant="h6" component="h2" gutterBottom fontWeight={"bold"}>
        Abschlussnotizen
      </Typography>
      <Divider sx={{ borderColor: "#f6891f", mb: 3 }} />
      {editable ? (
        <Stack spacing={2}>
          <Typography variant="body2" color="text.secondary">
            Die Notizen bleiben bis zum Projektabschluss bearbeitbar. Zum Abschließen werden mindestens {minLength}{" "}
            Zeichen benötigt.
          </Typography>
          {/* Keep the topic hint outside the field so it stays visible after users start typing. */}
          <Typography variant="body2" color="text.secondary">
            Mögliche Themen: Folgeprojektpotenzial, Auffälligkeiten in der Kommunikation, Verfügbarkeit
          </Typography>
          <TextField
            value={note}
            onChange={(event) => onChange(event.target.value)}
            multiline
            minRows={4}
            fullWidth
            helperText={`Aktuell ${trimmedLength}/${minLength} Zeichen.`}
          />
          {onSave ? (
            <Stack direction="row" justifyContent="flex-end">
              <Button variant="contained" onClick={onSave} disabled={saveDisabled || saveLoading}>
                Speichern
              </Button>
            </Stack>
          ) : null}
        </Stack>
      ) : (
        <Stack spacing={1}>
          <Typography variant="body2" color="text.secondary">
            Die Notizen sind nach dem Projektabschluss schreibgeschützt.
          </Typography>
          <Typography sx={{ whiteSpace: "pre-wrap" }}>{note.trim() || "-"}</Typography>
        </Stack>
      )}
    </Card>
  );
};

export default ProjectCompletionNoteCard;
